import { Toaster } from '@teivor/shared-ui';

import { AppRoutes } from './routes';
import { AppCookieBanner } from './components/AppCookieBanner';

export function App() {
  return (
    <>
      <AppRoutes />
      <Toaster />
      <AppCookieBanner />
    </>
  );
}
